var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6957 22.2929L16.0326 14.6298C17.2703 13.0882 18.0114 11.1307 18.0114 9C18.0114 4.0297 13.9816 0 9.01135 0C4.04106 0 0.0113525 4.0297 0.0113525 9C0.0113525 13.9703 4.04106 18 9.01135 18C11.1304 18 13.0782 17.2671 14.6159 16.0416L22.2814 23.7071C22.6719 24.0976 23.3051 24.0976 23.6956 23.7071C24.0863 23.3165 24.0863 22.6834 23.6957 22.2929ZM2.01142 8.99995C2.01142 5.13422 5.14571 1.99997 9.0114 1.99997C12.8771 1.99997 16.0114 5.13422 16.0114 8.99995C16.0114 10.9384 15.2232 12.6929 13.9499 13.9605C13.9498 13.9606 13.9496 13.9607 13.9495 13.9609C13.9495 13.9609 13.9494 13.961 13.9493 13.9611C12.6834 15.2211 10.9384 16 9.0114 16C5.14571 15.9999 2.01142 12.8657 2.01142 8.99995Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9886 8H5.98863C5.43635 8 4.98865 8.4477 4.98865 8.99998C4.98865 9.55227 5.43635 9.99997 5.98863 9.99997H11.9886C12.5409 9.99997 12.9886 9.55227 12.9886 8.99998C12.9886 8.4477 12.5409 8 11.9886 8Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.15554ec8bef75e6dccbce06e9932fcee.svg";
export { ForwardRef as ReactComponent };